import React from 'react';
import './ProjectDialog.css'; // We'll create this CSS file

function ProjectDialog({ project, onClose }) {
    if (!project) return null; // Don't render if no project is selected

    return (
        <div className="dialog-backdrop" onClick={onClose}>
            <div className="dialog-content" onClick={(e) => e.stopPropagation()}> {/* Prevent closing when clicking inside */}
                <button className="dialog-close-button" onClick={onClose}>&times;</button>
                <h2>{project.title}</h2>
                <div className="dialog-images">
                    {project.images.map((imageUrl, index) => (
                        <img 
                            key={index} 
                            src={imageUrl} 
                            alt={`${project.title} - Image ${index + 1}`} 
                            className="dialog-image" 
                        />
                    ))}
                </div>
                <p>{project.description}</p>
            </div>
        </div>
    );
}

export default ProjectDialog;